'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _DayPickerInput = require('react-day-picker/DayPickerInput');

var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);

require('react-day-picker/lib/style.css');

var _moment = require('react-day-picker/moment');

var _campaignSummary = require('./campaign-summary');

var _campaignSummary2 = _interopRequireDefault(_campaignSummary);

var _campaignHighlights = require('./campaign-highlights');

var _campaignHighlights2 = _interopRequireDefault(_campaignHighlights);

var _influencerCard = require('./influencer-card');

var _influencerCard2 = _interopRequireDefault(_influencerCard);

var _positiveSentiment = require('./positive-sentiment');

var _positiveSentiment2 = _interopRequireDefault(_positiveSentiment);

var _campaignOverview = require('./campaign-overview');

var _campaignOverview2 = _interopRequireDefault(_campaignOverview);

var _influencerReportCard = require('../influencer-report-card');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JL = 'cfa6155e-0b5e-4ebc-8150-c8715217fdc8';
var GIFTA = '2beaa438-af69-46f1-b639-f7ae1f374241';

var DATE_PICKER_DATE_FORMAT = 'DD/MM/YYYY';

var inputStyle = {
  margin: 5
};

var InstagramReport2 = function InstagramReport2(props) {
  //
  var _props$data$data = props.data.data,
      influencers = _props$data$data.influencers,
      totalLikes = _props$data$data.totalLikes,
      totalComments = _props$data$data.totalComments,
      totalViews = _props$data$data.totalViews,
      posts = _props$data$data.posts,
      tiktoks = _props$data$data.tiktoks;
  var campaign = props.campaign,
      datePeriodFilterValues = props.datePeriodFilterValues,
      onDateFilterChange = props.onDateFilterChange;
  var _props$data$meta = props.data.meta,
      postCount = _props$data$meta.postCount,
      storyCount = _props$data$meta.storyCount;

  // const allPosts = _.flattenDeep(_.compact(_.reduce(posts, (result, item) => {
  //   result.push(item.posts);
  //   return result;
  // }, [])));

  var summaryProps = {
    influencers: influencers,
    postCount: postCount,
    storyCount: storyCount,
    totalLikes: totalLikes,
    totalComments: totalComments,
    totalViews: totalViews,
    posts: posts,
    tiktoks: tiktoks
  };

  var documents = campaign.documents,
      overview = campaign.overview,
      owner = campaign.owner;


  var orgId = _lodash2.default.get(owner, 'id');
  console.log('orgId', orgId);

  var isJohnLewisReport = orgId === JL;
  var isGiftaReport = orgId === GIFTA;

  var overviewProps = {
    documents: documents,
    overview: overview
  };

  var discussionsWithIG = [];

  _lodash2.default.forEach(posts, function (p) {
    var discussionId = null;
    _lodash2.default.forEach(p.posts, function (post) {
      if (_lodash2.default.get(post, 'relationships.discussion.data.id')) {
        discussionId = _lodash2.default.get(post, 'relationships.discussion.data.id');
      } else if (_lodash2.default.get(post, 'discussionId')) {
        discussionId = _lodash2.default.get(post, 'discussionId');
      }
    });
    if (discussionId) {
      discussionsWithIG.push(discussionId);
    }
  });

  var getER = function getER(params) {
    if (isJohnLewisReport) {
      return (0, _influencerReportCard.getJLEngagementsRate)(params);
    } else if (isGiftaReport) {
      return (0, _influencerReportCard.getGiftaEngagementsRate)(params);
    }
    return (0, _influencerReportCard.getEngagementsRate)(params);
  };

  _lodash2.default.forEach(posts, function (record, handle) {
    _lodash2.default.assignIn(record, { handle: handle });
  });

  var postsWithER = _lodash2.default.filter(posts, 'totals.engagementsRate');
  var postsWithoutER = _lodash2.default.reject(posts, 'totals.engagementsRate');

  var sortedPostsWithEr = _lodash2.default.reverse(_lodash2.default.sortBy(postsWithER, 'totals.engagementsRate'));

  var sortedPosts = _lodash2.default.reverse(_lodash2.default.sortBy(posts, 'totals.engagementsRate'));

  console.log(postsWithER);
  console.log(postsWithoutER);
  console.log(sortedPosts);
  console.log(posts);

  console.log('discussionsWithIG', discussionsWithIG);

  var tiktoksOnlys = _lodash2.default.reject(tiktoks, function (tiktok) {
    return _lodash2.default.includes(discussionsWithIG, tiktok.discussion.id);
  });

  console.log('tiktoksOnlys', tiktoksOnlys);

  var tiktokOnlyHandles = _lodash2.default.uniq(_lodash2.default.map(tiktoksOnlys, function (tiktok) {
    return tiktok.discussionName;
  }));

  console.log('tiktokOnlyHandles', tiktokOnlyHandles);

  var tiktokGroups = _lodash2.default.groupBy(tiktoks, function (t) {
    return t.discussionName;
  });

  var tiktokArray = _lodash2.default.map(tiktokOnlyHandles, function (handle) {
    return tiktokGroups[handle];
  });

  console.log('tiktokArray', tiktokArray);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _semanticUiReact.Menu,
      null,
      _react2.default.createElement(
        _semanticUiReact.Menu.Menu,
        null,
        _react2.default.createElement(_DayPickerInput2.default, {
          component: function component(p) {
            return _react2.default.createElement(
              'div',
              { style: inputStyle, className: 'ui input' },
              _react2.default.createElement('input', p)
            );
          },
          onDayChange: function onDayChange(day) {
            return onDateFilterChange(day, 'start');
          },
          format: DATE_PICKER_DATE_FORMAT,
          dateFormat: DATE_PICKER_DATE_FORMAT,
          placeholder: 'Start date',
          formatDate: _moment.formatDate,
          parseDate: _moment.parseDate,
          value: datePeriodFilterValues.start
        }),
        _react2.default.createElement(_DayPickerInput2.default, {
          component: function component(p) {
            return _react2.default.createElement(
              'div',
              { style: inputStyle, className: 'ui input' },
              _react2.default.createElement('input', p)
            );
          },
          onDayChange: function onDayChange(day) {
            return onDateFilterChange(day, 'end');
          },
          format: DATE_PICKER_DATE_FORMAT,
          dateFormat: DATE_PICKER_DATE_FORMAT,
          placeholder: 'End date',
          formatDate: _moment.formatDate,
          parseDate: _moment.parseDate,
          value: datePeriodFilterValues.end
        })
      )
    ),
    _react2.default.createElement(_campaignSummary2.default, (0, _extends3.default)({}, summaryProps, { orgId: _lodash2.default.get(owner, 'id') })),
    overview && _lodash2.default.get(overview, 'shouldRender', false) && _react2.default.createElement(_campaignOverview2.default, overviewProps),
    _react2.default.createElement(_campaignHighlights2.default, { posts: posts }),
    _react2.default.createElement(_positiveSentiment2.default, { posts: posts }),
    _react2.default.createElement(_semanticUiReact.Divider, null),
    _lodash2.default.map(_lodash2.default.concat(sortedPostsWithEr, postsWithoutER), function (record, handle) {
      return _react2.default.createElement(_influencerCard2.default, (0, _extends3.default)({ handle: handle }, record, { tiktoks: tiktoks, orgId: _lodash2.default.get(owner, 'id') }));
    }),
    _lodash2.default.map(tiktokArray, function (influencerTiktoks) {
      return _react2.default.createElement(_influencerCard2.default, { tiktoks: influencerTiktoks, orgId: _lodash2.default.get(owner, 'id') });
    })
  );
};

InstagramReport2.propTypes = {
  data: _propTypes2.default.object.isRequired,
  campaign: _propTypes2.default.object.isRequired
};

InstagramReport2.defaultProps = {
  withHeader: false,
  onDateFilterChange: _lodash2.default.noop,
  datePeriodFilterValues: {
    start: new Date(),
    end: new Date()
  }
};

exports.default = InstagramReport2;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/instagram-report2/index.js
// module id = 2191
// module chunks = 1